import { IZipCodeResponse} from '@nkr/store/orders/actions'

export interface IBaseDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    lookUpZipCode: (code: string) => Promise<IZipCodeResponse>
};

export const PHLEBOT_REQUEST_FAILED_MESSAGE = 'Your order has been placed.';